'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleStyleCommand = undefined;

var _draftJs = require('draft-js');

var _richTextConstants = require('../../richText/richTextConstants');

// Lib
var handleStyleCommand = exports.handleStyleCommand = function handleStyleCommand(state, action) {
    var editorState = state;

    var selection = action.selection,
        styleCommand = action.styleCommand;


    var styleType = _richTextConstants.STYLE_COMMAND_TYPES[styleCommand];

    var toggleFn = styleType === _richTextConstants.STYLE_TYPES.INLINE ? _draftJs.RichUtils.toggleInlineStyle : _draftJs.RichUtils.toggleBlockType;

    if (selection) {
        editorState = _draftJs.EditorState.forceSelection(editorState, selection);
    }

    return toggleFn(editorState, styleCommand);
};

// Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/store/reducers/handleStyleCommand.js
// module id = 1752
// module chunks = 0